var ModalValidate = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerValidate.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Пожалуйста заполните LMC или подтвердите LS без LMC"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerValidate.close();
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerValidate = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerValidate.container = document.querySelector('#ModalValidate');
    if (!ModalContainerValidate.container) {
      ModalContainerValidate.container = document.createElement('div');
      ModalContainerValidate.container.id = 'ModalValidate';
      ModalContainerValidate.container.hidden = true;
      document.body.appendChild(ModalContainerValidate.container);
      m.mount(ModalContainerValidate.container, m.component(ModalValidate, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerValidate.container = document.querySelector('#ModalValidate');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerValidate.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerValidate.removeAll = removeAll;
    if (ModalContainerValidate.container) {
      // if(title){
      // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
      // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerValidate.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerValidate.container.hidden = true;
  }
};
